module.exports = __webpack_public_path__ + "media/assets/icons/go-5722f7b49088aef08bf589f39002bee6.svg";